// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__NNlHl","title":"styles_title__x-7Ld","formContainer":"styles_formContainer__jqJQT","buttonContainer":"styles_buttonContainer__b+eC5"};